var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6 9.6a7.2 7.2 0 0 1-9.291 6.891L9.6 19.2H7.2v2.4H2.4v-4.8L7.51 11.69A7.2 7.2 0 1 1 21.6 9.6Zm-7.2-4.8a1.2 1.2 0 1 0 0 2.4 2.4 2.4 0 0 1 2.4 2.4 1.2 1.2 0 0 0 2.4 0 4.8 4.8 0 0 0-4.8-4.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.ea007632ba4988557cf52672b4207e5b.svg";
export { ForwardRef as ReactComponent };